import { makeStyles } from '@material-ui/core';

const useDocumentPanelStyles = makeStyles((theme) => {
    return({
        documentPanelSuccessAdditionalNotes: {
            marginBottom: '20px !important',
            padding: '0px 20px',
            color: 'var(--mid-green)'
        },
        documentPanelFailureAdditionalNotes: {
            marginBottom: '20px !important',
            padding: '0px 20px',
            color: 'var(--warning-orange)'
        }
    });
});

export default useDocumentPanelStyles;
